<div class="p-grid dashboard">
    <div class="p-col-12 p-md-8">
        <div class="card height-100">
            <div class="card-header">
                <h5>Monthly Comparison</h5>
                <button pRipple pButton type="button" label="Vertical/Stacked Data" class="p-button-text" [ngClass]="{'p-ml-auto': !app.isRTL, 'p-mr-auto': app.isRTL}" (click)="changeMonthlyDataView()"></button>
            </div>

            <p-chart #bar type="bar" [data]="chartMonthlyData" [options]="chartMonthlyOptions" responsive="true" height="400px"></p-chart>
        </div>
    </div>

    <div class="p-col-12 p-md-4">
        <div class="card widget-insights height-100">
            <div class="card-header p-mb-2">
                <h5>Insights</h5>
                <div>
                    <button pButton pRipple type="button" icon="pi pi-ellipsis-h" class="p-button-rounded p-button-text p-button-plain" (click)="menu11.toggle($event)"></button>
                    <p-menu #menu11 [popup]="true" [model]="[{label: 'Update', icon: 'pi pi-fw pi-refresh'},{label: 'Edit', icon: 'pi pi-fw pi-pencil'}]"></p-menu>
                </div>
            </div>
            <div class="card-subheader p-mb-2 p-d-flex p-ai-center">
                <span>November 22 - November 29</span>
                <button pRipple pButton type="button" label="Semi/Full Data" class="p-button-text" [ngClass]="{'p-ml-auto': !app.isRTL, 'p-mr-auto': app.isRTL}" (click)="changeDoughnutDataView()"></button>
            </div>
            <p-chart #doughnut type="doughnut" [data]="doughnutData" [options]="doughnutOptions" responsive="true"></p-chart>
            <div class="p-d-flex p-flex-column p-jc-center">
                <div class="p-d-flex p-flex-row p-ai-center p-mt-4 p-px-3">
                    <i class="pi pi-thumbs-up p-p-3 rounded-circle lightgreen-bgcolor solid-surface-text-color"></i>
                    <div class="p-d-flex p-flex-column" [ngClass]="{'p-ml-3': !app.isRTL, 'p-mr-3': app.isRTL}">
                        <span>Best Day of the Week</span>
                        <small>Friday</small>
                    </div>
                    <span class="indigo-color" [ngClass]="{'p-ml-auto': !app.isRTL, 'p-mr-auto': app.isRTL}">95</span>
                </div>
                <div class="p-d-flex p-flex-row p-ai-center p-my-4 p-px-3">
                    <i class="pi pi-thumbs-down rounded-circle p-p-3 orange-bgcolor solid-surface-text-color"></i>
                    <div class="p-d-flex p-flex-column" [ngClass]="{'p-ml-3': !app.isRTL, 'p-mr-3': app.isRTL}">
                        <span>Worst Day of the Week</span>
                        <small>Saturday</small>
                    </div>
                    <span class="indigo-color" [ngClass]="{'p-ml-auto': !app.isRTL, 'p-mr-auto': app.isRTL}">6</span>
                </div>
            </div>
        </div>
    </div>

    <div class="p-col-12 p-md-4">
        <div class="card widget-social">
            <div class="p-d-flex p-jc-between p-ai-center p-p-3">
                <div class="social-icon">
                    <i class="pi pi-twitter blue-color fs-xxlarge"></i>
                </div>
                <div class="info p-d-flex p-flex-column">
                    <span class="value">44.995</span>
                    <span class="subtext p-mt-2">Retweets</span>
                </div>
            </div>

            <div class="stats p-d-flex p-jc-between p-mt-3">
                <div class="left p-d-flex p-flex-column ">
                    <span class="title">Target</span>
                    <span class="value p-mb-2">10.000</span>
                    <p-progressBar [value]="50" [showValue]="false"></p-progressBar>
                </div>
                <div class="right p-d-flex p-flex-column">
                    <span class="title">All Time Record</span>
                    <span class="value p-mb-2">50.702</span>
                    <p-progressBar [value]="24" [showValue]="false"></p-progressBar>
                </div>
            </div>
        </div>
    </div>

    <div class="p-col-12 p-md-4">
        <div class="card widget-social">
            <div class="p-d-flex p-jc-between p-ai-center p-p-3">
                <div class="social-icon">
                    <i class="pi pi-facebook indigo-color fs-xxlarge"></i>
                </div>
                <div class="info p-d-flex p-flex-column">
                    <span class="value">44.995</span>
                    <span class="subtext p-mt-2">Facebook Interactions</span>
                </div>
            </div>

            <div class="stats p-d-flex p-jc-between p-mt-3">
                <div class="left p-d-flex p-flex-column ">
                    <span class="title">Target</span>
                    <span class="value p-mb-2">10.000</span>
                    <p-progressBar [value]="23" [showValue]="false"></p-progressBar>
                </div>
                <div class="right p-d-flex p-flex-column">
                    <span class="title">All Time Record</span>
                    <span class="value p-mb-2">99.028</span>
                    <p-progressBar [value]="38" [showValue]="false"></p-progressBar>
                </div>
            </div>
        </div>
    </div>

    <div class="p-col-12 p-md-4">
        <div class="card widget-social">
            <div class="p-d-flex p-jc-between p-ai-center p-p-3">
                <div class="social-icon">
                    <i class="pi pi-github text-color fs-xxlarge"></i>
                </div>
                <div class="info p-d-flex p-flex-column">
                    <span class="value">81.002</span>
                    <span class="subtext p-mt-2">Star</span>
                </div>
            </div>

            <div class="stats p-d-flex p-jc-between p-mt-3">
                <div class="left p-d-flex p-flex-column ">
                    <span class="title">Target</span>
                    <span class="value p-mb-2">10.000</span>
                    <p-progressBar [value]="62" [showValue]="false"></p-progressBar>
                </div>
                <div class="right p-d-flex p-flex-column">
                    <span class="title">All Time Record</span>
                    <span class="value p-mb-2">162.550</span>
                    <p-progressBar [value]="14" [showValue]="false"></p-progressBar>
                </div>
            </div>
        </div>
    </div>

    <div class="p-col-12 p-md-12">
        <div class="card p-grid p-nogutter widget-sales p-d-block p-d-sm-flex">
            <div class="p-lg-3 p-md-6 p-sm-12 p-p-0">
                <div class="sales-info p-d-flex p-flex-column p-p-4">
                    <span class="muted-text">Store A Sales</span>
                    <span class="fs-large p-mt-2">
                        <i *ngIf="storeADiff !== 0" class="fw-700 fs-large pi" [ngClass]="{'p-pr-1': !app.isRTL, 'p-pl-1': app.isRTL, 'pi-arrow-up green-color': storeADiff > 0, 'pi-arrow-down pink-color': storeADiff < 0}"></i>
                        ${{storeATotalValue}}
                        <span *ngIf="storeADiff !== 0" class="fw-500 fs-normal" [ngClass]="{'p-ml-1': !app.isRTL, 'p-mr-1': app.isRTL, 'green-color': storeADiff > 0, 'pink-color': storeADiff < 0}">
                            {{storeADiff > 0 ? '+' : ''}}{{storeADiff}}
                        </span>
                    </span>
                </div>
                <div class="p-px-4">
                    <p-chart #storeA type="line" [data]="storeAData" [options]="storeOptions" responsive="true"></p-chart>
                </div>
            </div>
            <div class="p-lg-3 p-md-6 p-sm-12 p-p-0">
                <div class="sales-info p-d-flex p-flex-column p-p-4">
                    <span class="muted-text">Store B Sales</span>
                    <span class="fs-large p-mt-2">
                        <i *ngIf="storeBDiff !== 0" class="fw-700 fs-large pi" [ngClass]="{'p-pr-1': !app.isRTL, 'p-pl-1': app.isRTL, 'pi-arrow-up green-color': storeBDiff > 0, 'pi-arrow-down pink-color': storeBDiff < 0}"></i>
                        ${{storeBTotalValue}}
                        <span *ngIf="storeBDiff !== 0" class="fw-500 fs-normal" [ngClass]="{'p-ml-1': !app.isRTL, 'p-mr-1': app.isRTL,'green-color': storeBDiff > 0, 'pink-color': storeBDiff < 0}">
                            {{storeBDiff > 0 ? '+' : ''}}{{storeBDiff}}
                        </span>
                    </span>
                </div>
                <div class="p-px-4">
                    <p-chart #storeB type="line" [data]="storeBData" [options]="storeOptions" responsive="true"></p-chart>
                </div>
            </div>
            <div class="p-lg-3 p-md-6 p-sm-12 p-p-0">
                <div class="sales-info p-d-flex p-flex-column p-p-4">
                    <span class="muted-text">Store C Sales</span>
                    <span class="fs-large p-mt-2">
                        <i *ngIf="storeCDiff !== 0" class="fw-700 fs-large pi" [ngClass]="{'p-pr-1': !app.isRTL, 'p-pl-1': app.isRTL, 'pi-arrow-up green-color': storeCDiff > 0, 'pi-arrow-down pink-color': storeCDiff < 0}"></i>
                        ${{storeCTotalValue}}
                        <span *ngIf="storeCDiff !== 0" class="fw-500 fs-normal" [ngClass]="{'p-ml-1': !app.isRTL, 'p-mr-1': app.isRTL, 'green-color': storeCDiff > 0, 'pink-color': storeCDiff < 0}">
                            {{storeCDiff > 0 ? '+' : ''}}{{storeCDiff}}
                        </span>
                    </span>
                </div>
                <div class="p-px-4">
                    <p-chart #storeC type="line" [data]="storeCData" [options]="storeOptions" responsive="true"></p-chart>
                </div>
            </div>
            <div class="p-lg-3 p-md-6 p-sm-12 p-p-0">
                <div class="sales-info p-d-flex p-flex-column p-p-4">
                    <span class="muted-text">Store D Sales</span>
                    <span class="fs-large p-mt-2">
                        <i *ngIf="storeDDiff !== 0" class="fw-700 fs-large pi" [ngClass]="{'p-pr-1': !app.isRTL, 'p-pl-1': app.isRTL, 'pi-arrow-up green-color': storeDDiff > 0, 'pi-arrow-down pink-color': storeDDiff < 0}"></i>
                        ${{storeDTotalValue}}
                        <span *ngIf="storeDDiff !== 0" class="fw-500 fs-normal" [ngClass]="{'p-ml-1': !app.isRTL, 'p-mr-1': app.isRTL, 'green-color': storeDDiff > 0, 'pink-color': storeDDiff < 0}">
                            {{storeDDiff > 0 ? '+' : ''}}{{storeDDiff}}
                        </span>
                    </span>
                </div>
                <div class="p-px-4">
                    <p-chart #storeD type="line" [data]="storeDData" [options]="storeOptions" responsive="true"></p-chart>
                </div>
            </div>
        </div>
    </div>

    <div class="p-col-12 p-md-6">
        <div class="card height-100 widget-topsearchs">
            <div class=card-header>
                <h5>Top Searchs</h5>
                <div>
                    <button pButton pRipple type="button" icon="pi pi-ellipsis-h" class="p-button-rounded p-button-text p-button-plain" (click)="menu12.toggle($event)"></button>
                    <p-menu #menu12 [popup]="true" [model]="[{label: 'Update', icon: 'pi pi-fw pi-refresh'},{label: 'Edit', icon: 'pi pi-fw pi-pencil'}]"></p-menu>
                </div>
            </div>
            <div class="p-d-flex p-jc-between item">
                <span>Mat Orange Case</span>
                <span class="value type-green">82% CONV RATE</span>
            </div>
            <div class="p-d-flex p-jc-between item">
                <span>Space T-Shirt</span>
                <span class="value type-green">78% CONV RATE</span>
            </div>
            <div class="p-d-flex p-jc-between item">
                <span>Orange Black Hoodie</span>
                <span class="value type-green">61% CONV RATE</span>
            </div>
            <div class="p-d-flex p-jc-between item">
                <span>Wonders Notebook</span>
                <span class="value type-yellow">48 CONV RATE</span>
            </div>
            <div class="p-d-flex p-jc-between item">
                <span>Robots T-Shirt</span>
                <span class="value type-yellow">34% CONV RATE</span>
            </div>
            <div class="p-d-flex p-jc-between item">
                <span>Green Portal Sticker</span>
                <span class="value type-pink">11% CONV RATE</span>
            </div>
        </div>
    </div>

    <div class="p-col-12 p-md-6">
        <div class="card">
            <p-table [value]="products" [paginator]="true" [rows]="4" styleClass="p-datatable-products">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:5rem">Image</th>
                        <th pSortableColumn="name">Name
                            <p-sortIcon field="name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="category">Category
                            <p-sortIcon field="category"></p-sortIcon>
                        </th>
                        <th pSortableColumn="price">Price
                            <p-sortIcon field="price"></p-sortIcon>
                        </th>
                        <th style="width:4rem">View</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>
                            <img [src]="'assets/demo/images/product/' + product.image" [alt]="product.image" width="50px" class="p-shadow-4" />
                        </td>
                        <td>
                            <span class="p-column-title">Name</span>
                            {{product.name}}
                        </td>
                        <td>
                            <span class="p-column-title">Category</span>
                            {{product.category}}
                        </td>
                        <td>
                            <span class="p-column-title">Price</span>
                            {{product.price | currency:'USD'}}
                        </td>
                        <td>
                            <span class="p-column-title">View</span>
                            <button pRipple pButton type="button" icon="pi pi-search" class="p-button-rounded p-button-text p-mb-1" [ngClass]="{'p-mr-2': !app.isRTL, 'p-ml-2': app.isRTL}"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <div class="p-col-12 p-md-4">
        <div class="card widget-expenses">
            <div class=card-header>
                <h5>Expenses</h5>
                <div>
                    <button pButton pRipple type="button" icon="pi pi-ellipsis-h" class="p-button-rounded p-button-text p-button-plain" (click)="menu13.toggle($event)"></button>
                    <p-menu #menu13 [popup]="true" [model]="[{label: 'Update', icon: 'pi pi-fw pi-refresh'},{label: 'Edit', icon: 'pi pi-fw pi-pencil'}]"></p-menu>
                </div>
            </div>
            <div class="card-subheader p-mb-2 p-pb-3">
                November 22 - November 29
            </div>

            <div class="p-d-flex p-jc-between p-ai-center p-my-2 item">
                <div class="p-d-flex p-flex-column">
                    <i class="pi pi-cloud type p-mb-2"></i>
                    <span class="value p-mb-1">$30.247</span>
                    <span class="subtext">Cloud Infrastructure</span>
                </div>
                <span class="item-button"><a href="#"><i class="pi pi-chevron-right"></i></a></span>
            </div>
            <div class="p-d-flex p-jc-between p-ai-center p-my-2 item">
                <div class="p-d-flex p-flex-column">
                    <i class="pi pi-tag type p-mb-2"></i>
                    <span class="value p-mb-1">$29.550</span>
                    <span class="subtext">General Goods</span>
                </div>
                <span class="item-button"><a href="#"><i class="pi pi-chevron-right"></i></a></span>
            </div>
            <div class="p-d-flex p-jc-between p-ai-center p-my-2 item">
                <div class="p-d-flex p-flex-column">
                    <i class="pi pi-desktop type p-mb-2"></i>
                    <span class="value p-mb-1">$16.660</span>
                    <span class="subtext">Consumer Electronics</span>
                </div>
                <span class="item-button"><a href="#"><i class="pi pi-chevron-right"></i></a></span>
            </div>
            <div class="p-d-flex p-jc-between p-ai-center p-my-2 item">
                <div class="p-d-flex p-flex-column">
                    <i class="pi pi-compass type p-mb-2"></i>
                    <span class="value p-mb-1">$5.801</span>
                    <span class="subtext">Incalculables</span>
                </div>
                <span class="item-button"><a href="#"><i class="pi pi-chevron-right"></i></a></span>
            </div>
        </div>
    </div>

    <div class="p-col-12 p-md-8">
        <div class="card widget-traffic height-100">
            <div class="card-header">
                <h5>All Traffic Channels</h5>
                <button pRipple pButton type="button" label="Pie/Doughnut Data" class="p-button-text" [ngClass]="{'p-ml-auto': !app.isRTL, 'p-mr-auto': app.isRTL}" (click)="togglePieDoughnut()"></button>
                <button pRipple pButton type="button" label="Semi/Full Data" class="p-button-text p-mx-2" (click)="changePieDoughnutDataView()"></button>
            </div>
            <div class="p-d-flex p-grid">
                <div class="p-col-12 p-md-6 left p-d-flex p-flex-column p-jc-evenly">
                    <div class="total p-d-flex p-flex-column">
                        <span class="title p-mb-2">Total</span>
                        <span class="value p-mb-5">66.761</span>
                    </div>

                    <div class="info p-d-flex p-jc-between">
                        <div class="organic p-d-flex p-flex-column">
                            <span class="title p-mb-1">Organic</span>
                            <span class="value">51.596</span>
                        </div>
                        <div class="direct p-d-flex p-flex-column">
                            <span class="title p-mb-1">Direct</span>
                            <span class="value">11.421</span>
                        </div>
                        <div class="referral p-d-flex p-flex-column">
                            <span class="title p-mb-1">Referral</span>
                            <span class="value">3.862</span>
                        </div>
                    </div>
                </div>
                <div class="p-col-12 p-md-6 right p-d-flex p-jc-center">
                    <p-chart #pie type="pie" [data]="pieData" [options]="pieOptions"></p-chart>
                </div>
            </div>
        </div>
    </div>
</div>
